import { colorCSS } from "./colors";

export const shadow = {
    dark: `0 0.5rem 1rem 0 ${colorCSS("N900", 0.25)}`,
    normal: `0 0.5rem 1rem 0 ${colorCSS("N900", 0.15)}`,
    normal_inset: `inset 0 1.5rem 1rem -1rem ${colorCSS("N900", 0.15)}`,
    small: `1px 1px 5px 0 ${colorCSS("N900", 0.15)}`
};
